function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 243 489",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M119.781 241.051c38.336 0 68.29-27.967 68.29-27.967 3.232.537 6.612 8.913 8.078 34.556 1.816 31.762 14.086 43.283 18.991 108.884 4.901 65.602-4.498 116.665-4.498 116.665-26.317 19.341-61.537 3.403-61.537 3.403-1.392-25.586-10.164-40.276-11.712-68.9-2.113-39.055-10.12-51.168-17.571-51.168h-.044c-7.323 0-15.502 12.113-17.616 51.168-1.548 28.624-10.32 43.317-11.712 68.9 0 0-33.005 16.162-61.537-3.403 0 0-9.398-51.063-4.497-116.665 4.9-65.601 17.171-77.122 18.99-108.884 1.467-25.64 4.847-34.019 8.078-34.556 0 0 29.3 27.967 67.637 27.967h.66z",
  stroke: "currentColor",
  strokeWidth: "12",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.136 6.047c.095 1.458 2.689 197.024 1.03 217.671L51.49 213.084 45.055 17.382 65.088 6.024c.02-.01.044 0 .048.023zM171.221 6.254a.062.062 0 00-.089.057c.072 2.463-2.228 166.145 3.536 216.464l13.233-9.715 3.553-196.625-20.233-10.181z",
  stroke: "currentColor",
  strokeWidth: "12",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M173.389 208.365s-7.556-.257-13.266 1.864c-8.573 3.186-15.489 10.756-39.641 10.756h-.701c-24.152 0-31.77-7.57-40.342-10.756-5.71-2.121-13.266-1.864-13.266-1.864M104.513 84.191c-13.723 24.351-26.008 52.122-37.794 94.614M171.13 6.21s-32.989 30.466-52.443 58.948M131.994 86.87c7.546-17.268 39.136-46.175 39.136-46.175M79.439 210.232c2.889-22.254 26.892-81.733 37.858-100.404",
  stroke: "currentColor",
  strokeWidth: "12",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.133 6L97.69 39.345a198.086 198.086 0 0138.069 55.23c12.644 27.332 29.69 66.167 36.481 90.643M156.702 211.237l-39.13-100.696a164.51 164.51 0 00-30.81-50.187l-21.21-23.678",
  stroke: "currentColor",
  strokeWidth: "12",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41 244.5c-17-3-44.975 5.868-34.5 21 13.5 19.5 82.167 16.333 115.501 16",
  stroke: "currentColor",
  strokeWidth: "8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M197.776 251.474c19.051-2.449 50.403 4.791 38.663 17.146C221.31 284.541 158.356 281.772 121 281.5",
  stroke: "currentColor",
  strokeWidth: "8"
})));